import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/quality-assurance/qualified-person-qp-responsible-person-rp")({
  beforeLoad: () => { throw redirect({ to: "/en/services/quality-assurance/qp-rp-prrc-services", statusCode: 301 }); },
});
